import type { CSSProperties } from 'react';

export const SKYX_NEW_MODAL_DIALOG_CLASS = 'skyx-new-modal-dialog';

/** Popup copy uses Roboto (game HUD uses Roboto Condensed). */
export const SKYX_MODAL_FONT = "'Roboto', sans-serif";

/** Marks a skyx_new popup panel root — pairs with font rules in SkyxNewFonts.css. */
export const SKYX_POPUP_ROOT_ATTR = 'data-skyx-popup';

/** Border — matches Auto Play popup (skyx_new). */
export const SKYX_MODAL_CHROME = {
  border: '1px solid rgba(143,77,255,0.45)',
  boxShadow: 'none',
  overlayBg: 'rgba(20, 0, 51, 0.4)',
  overlayPadding:
    'max(28px, calc(var(--headerHeightDynamic, 42px) + 12px)) 24px max(28px, env(safe-area-inset-bottom, 0px))',
  borderRadius: '24px',
  borderRadiusCompact: '20px',
} as const;

/** Merge autoplay-style panel border into a modal panel style object. */
export function skyxNewModalPanelChrome(
  overrides?: CSSProperties
): CSSProperties {
  return {
    position: 'relative',
    border: SKYX_MODAL_CHROME.border,
    boxShadow: SKYX_MODAL_CHROME.boxShadow,
    fontFamily: SKYX_MODAL_FONT,
    ...overrides,
  };
}

/** Backdrop styles shared by skyx_new modals. */
export function skyxNewModalOverlayChrome(
  overrides?: CSSProperties
): CSSProperties {
  return {
    position: 'fixed',
    inset: 0,
    backgroundColor: SKYX_MODAL_CHROME.overlayBg,
    overflowX: 'visible',
    overflowY: 'auto',
    padding: SKYX_MODAL_CHROME.overlayPadding,
    ...overrides,
  };
}
